module.exports = __webpack_public_path__ + "static/media/image (59).13a61764.jpg";